import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { msalAuth } from '../../shared/auth/MsalAuthProvider';
import { IUser } from '../../shared/models/User.model';
import { Utility, URLHelper } from '../../shared/models/Helper';
import ITenant from '../../shared/models/Tenant.model';
import { axioClient } from '../../shared/api/axios';
import { Role, RoleAssignment } from '../../shared/models/Role.model';
import { DetailsList, IColumn, SelectionMode, DetailsListLayoutMode, Fabric, Label, ScrollablePane, Sticky, StickyPositionType, DialogType, Link, getId, MessageBar, MessageBarType, IconButton, mergeStyles, TextField, DefaultButton, PrimaryButton, Icon } from '@fluentui/react';
import EditPane from './EditPane';
import { NeutralColors } from '@fluentui/theme';
import AccessAPI from '../../store/AccessAPI';
import { UIConstants } from '../../shared/models/Constants';
import { DialogModel } from '../../shared/models/Dialog.model';
import { ModalDialog } from '../ModalDialog';
import { AccessRequestRemovalByAdminModel } from '../../shared/models/UserAccess.model';
interface PermissionEditModel {
    actions: string[];
    notActions: string[];
    condition: string;
}

interface AuthDefinitionsState {
  roles: Role[];
  loading: boolean;
  error: string | null;
  tenantId: string | null;
  tenantName: string;
  userDetails: IUser | null;
  tenantData: ITenant | null;
  selectedRole: Role | RoleAssignment | null;
  isPaneOpen: boolean;
  editedDescription: string;
  editedName: string;
  editedScope: string;
  columns: IColumn[];
  adminRoles: RoleAssignment[];
  adminLoading: boolean;
  adminError: string | null;
  adminColumns: IColumn[];
  isInEuaEng?: boolean;
  isSubmitting: boolean;
  submitDisabled: boolean;
  nextPageUrl?: string | null;
  editedPermission: PermissionEditModel;
  searchPrincipalId: string;
  searchRoleName: string;
  editPaneMessage?: string | null;
  isRoleUpdated?: boolean;
  isCreateNew?: boolean;
  showDialog: boolean;
  modalDialogContent: any;
  showMessage: boolean;
  message: string;
  isUserAssignmentButtonClick: boolean;
  userUpn: string;
  attributeValue: any;
  comments: string;
  offset?: number;
  showRecordLimitWarning: boolean;
  isSearchApplied: boolean;
}

type AuthDefinitionsProps = RouteComponentProps<{ tenantName: string }>;

export default class AuthDefinitions extends React.Component<AuthDefinitionsProps, AuthDefinitionsState> {
  private _labelId: string = getId('dialogLabel');
  private _subTextId: string = getId('subTextLabel');
  private _modalDialogContent: DialogModel = {
    type: DialogType.normal,
    title: UIConstants.MessageBoxTitle.SaveAccess,
    closeButtonAriaLabel: UIConstants.ButtonText.Close,
    subText: UIConstants.Messages.SaveConfirmation,
    okAction: null,
    cancelAction: null,
  };
  constructor(props: AuthDefinitionsProps) {
    super(props);
    this.state = {
      roles: [],
      loading: false,
      error: null,
      tenantId: null,
      tenantName: this.props.match.params.tenantName,
      userDetails: null,
      tenantData: null,
      selectedRole: null,
      isPaneOpen: false,
      editedDescription: '',
      editedName: '',
      editedScope: '',
      columns: [],
      adminRoles: [],
      adminLoading: false,
      adminError: null,
      adminColumns: [],
      isInEuaEng: false,
      isSubmitting: false,
      submitDisabled: false,
      nextPageUrl: null,
      editedPermission: { actions: [], notActions: [], condition: '' },
      searchPrincipalId: '',
      searchRoleName: '',
      editPaneMessage: null,
      isRoleUpdated: false,
      isCreateNew: false,
      showDialog: false,
      modalDialogContent: this._modalDialogContent,
      showMessage: false,
      message: '',
      isUserAssignmentButtonClick: false,
      userUpn: '',
      attributeValue: {},
      comments: '',
      offset: 0,
      showRecordLimitWarning: false,
      isSearchApplied: false,
    };
  }

  async componentDidMount() {
    let userAccount = msalAuth.getAccount();
    let user: IUser = userAccount ? { PrincipalId: userAccount.accountIdentifier, Alias: userAccount.userName, Name: userAccount.name } : null;
    this.setState({ userDetails: user });
    let TenantData = Utility.GetTenantData();
    let tenantName = this.state.tenantName;
    let tenantData = TenantData.find(x => x.TenantName.toUpperCase() === tenantName.toUpperCase());
    this.setState({ tenantData: tenantData });
    if (user && tenantData) {
      this.setState({ tenantId: tenantData.TenantId, loading: true }, () => {
        this.fetchRoleDefinitions();
        this.fetchRoleAssignments();
        //this.checkUserGroups(); //currently not necessary, but may want this in case we find we can hit the page directly
      });
    }
  }
  handleCreateRoleDefinition = async () => {
    const { tenantId, tenantData } = this.state;
    if (!tenantId) return;
    this.setState({
      isPaneOpen: true, isRoleUpdated: true, selectedRole: {
        id: '', roleName: '', roleDescription: '', sortOrder: '999', attributes: ['UserAlias', 'RoleSetToExpire'], permissions: null, Scopes: [tenantData.TenantName], condition: "(@Resource.UserAliasResource == @Subject.UserAlias || @Resource.RoleSetToExpireResource == @Subject.RoleSetToExpire) || (@Environment.UseInlineSubjectAttributeValues == 'true')"
      }, isCreateNew: true
    });
  };
  fetchRoleDefinitions = async () => {
    const { tenantId, tenantData } = this.state;
    if (!tenantId) return;
    this.setState({ loading: true, error: null });
    try {
      const url = URLHelper.GetAdminViewRoles(tenantId);
      const response = await axioClient.get(url);
      const roles = response.data || [];
      this.setState({ roles, columns: this.getRoleDefinitionColumns(), loading: false });
    } catch (err) {
      this.setState({ error: err.message || 'Unknown error', loading: false });
    }
  };

  fetchRoleAssignments = async (nextPageUrl = '') => {
    const { tenantId, tenantData, offset } = this.state;
    if (!tenantId) return;
    let offSet = offset;
    this.setState({ adminLoading: true, adminError: null, searchPrincipalId: '', isSearchApplied: false, showRecordLimitWarning: false });
    try {
      const url = URLHelper.GetPagedRoleAssignments(tenantId, offSet.toString());
      const response = await axioClient.post(url, { nextPageUrl });
      const userAccesses: RoleAssignment[] = response.data && response.data.userAccesses ? response.data.userAccesses : [];
      const adminColumns = this.getDynamicRoleAssignmentColumns(userAccesses);
      const nextPage = response.data && response.data.nextPageUrl ? response.data.nextPageUrl : null;
      this.setState({ adminRoles: userAccesses, adminColumns, adminLoading: false, nextPageUrl: nextPage, offset: (userAccesses.length == 100 ? offset + userAccesses.length : 0) });
    } catch (err) {
      this.setState({ adminError: err.message || 'Unknown error', adminLoading: false });
    }
  };
  removeRoleAssignment = (item: RoleAssignment) => {
    const { tenantData } = this.state;
    let requestData: AccessRequestRemovalByAdminModel =
    {
      tenantId: tenantData.TenantId,
      roleId: item["roleDefinitionId"],
      rolename: item["roleName"],
      roleAssignmentId: item["id"],
      userId: item["principalId"],
      businessGroup: null,
      businessJustification: "Removed from Auth Definitions"
    };
    // Call API to remove role assignment
    AccessAPI.RemoveAccessRequestByEUATeam(requestData).then((data) => {
      if (data.status && data.status === 200) {
        this.setState({
          message: UIConstants.Messages.RemoveSuccess, showMessage: true
        });
        this.fetchRoleAssignments();
      } else {
        if (data.message) {
          this.setState({
            message: data.message, showMessage: true
          });
        }
        else {
          this.setState({
            message: UIConstants.Messages.RemoveFailure, showMessage: true
          });
        }
      }
    });
    this.setState({ showDialog: false });
  };

  removeRole = (item: Role) => {
    const { tenantData } = this.state;
    // Call API to remove role
    AccessAPI.RemoveRoleByEUATeam(tenantData.TenantId, item.id).then((data) => {
      if (data.status && data.status === 200) {
        this.setState({
          message: UIConstants.Messages.RoleRemovalSuccess, showMessage: true
        });
        this.fetchRoleDefinitions();
      } else {
        if (data.message) {
          this.setState({
            message: data.message, showMessage: true
          });
        }
        else {
          this.setState({
            message: UIConstants.Messages.RemoveFailure, showMessage: true
          });
        }
      }
    });
    this.setState({ showDialog: false });
  };
  addUserToRole = (item: Role) => {
    const { tenantData, userUpn, attributeValue, comments } = this.state;
    if (comments.trim().length === 0 || comments.replaceAll(" ", "") == '') {
      this.setState({
        message: UIConstants.Messages.InvalidReason, showMessage: true
      });
    }
    else {
      const roleAssignment: RoleAssignment = {
        roleDefinitionId: item.id,
        principalId: userUpn,
        roleName: item.name,
        roleDescription: item.description,
        attributes: attributeValue,
        condition: comments
      };
      // Call API to add user to role
      AccessAPI.AddUserToRoleByEUATeam(tenantData.TenantId, roleAssignment).then((data) => {
        if (data.status && data.status === 200) {
          this.setState({
            message: UIConstants.Messages.UserAdditionSuccess, showMessage: true, isUserAssignmentButtonClick: false, showDialog: false,
            userUpn: '', attributeValue: {}, comments: '', selectedRole: null
          });
          this.fetchRoleAssignments();
        } else {
          if (data.message) {
            this.setState({
              message: data.message, showMessage: true
            });
          }
          else {
            this.setState({
              message: UIConstants.Messages.SaveFailure, showMessage: true
            });
          }
        }
      });
    }
  };
  // Utility function to capitalize the first letter of a string
  capitalizeFirstLetter = (key: string) => key.charAt(0).toUpperCase() + key.slice(1);

  // Utility function to render cell value for DetailsList columns
  renderCellValue = (item: any, key: string) => {
    return typeof item[key] === 'object' && item[key] !== null
      ? JSON.stringify(item[key])
      : String(item[key] ?? '');
  };

  getDynamicRoleAssignmentColumns = (roleAssignments: RoleAssignment[]): IColumn[] => {
    if (!roleAssignments || roleAssignments.length === 0) return [];
    const excludeKeys = ['tenantname', 'tenantid', 'nextpageuri', 'nextpageurl', 'nextpageurl'.toLowerCase(), 'policy', 'isactive'];
    const keys = Array.from(
      roleAssignments.reduce((set: Set<string>, item: RoleAssignment) => {
        Object.keys(item).forEach((k: string) => set.add(k));
        return set;
      }, new Set<string>())
    ).filter((key: string) => typeof key === 'string' && !excludeKeys.includes(key.toLowerCase()));
    const columns: any = keys.map((key: string) => ({
      key,
      name: this.capitalizeFirstLetter(key),
      fieldName: key,
      minWidth: 100,
      maxWidth: 300,
      isResizable: true,
      onRender: (item: RoleAssignment) => this.renderCellValue(item, key)
    }));
    // Add Edit Column
    columns.push({ key: 'edit', name: '', fieldName: 'edit', minWidth: 80, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn });
    // Add Delete column
    columns.push({ key: 'delete', name: '', fieldName: 'delete', minWidth: 80, maxWidth: 100, isResizable: false, onRender: this._onRenderItemColumn });
    return columns;
  };
  private onRemoveAssignmentClick(item) {
    let msgText = "Are you sure you want to remove the role assignment?"
    this._modalDialogContent = {
      subText: msgText,
      title: UIConstants.MessageBoxTitle.RemoveAccess,
      okButtonText: UIConstants.ButtonText.Ok,
      type: DialogType.normal,
      okAction: () => this.removeRoleAssignment(item),
      cancelAction: this.closeRemoveConfirmation,
      closeMessageAction: this.closeRemoveConfirmation,
      closeButtonAriaLabel: UIConstants.ButtonText.Cancel,
    }
    this.setState({ showDialog: true, modalDialogContent: this._modalDialogContent });
  }
  private onRemoveRoleClick(item) {
    let msgText = "Are you sure you want to delete the role?"
    this._modalDialogContent = {
      subText: msgText,
      title: UIConstants.MessageBoxTitle.RemoveRole,
      okButtonText: UIConstants.ButtonText.Ok,
      type: DialogType.normal,
      okAction: () => this.removeRole(item),
      cancelAction: this.closeRemoveConfirmation,
      closeMessageAction: this.closeRemoveConfirmation,
      closeButtonAriaLabel: UIConstants.ButtonText.Cancel,
    }
    this.setState({ showDialog: true, modalDialogContent: this._modalDialogContent });
  }
  private onAssignUserButtonClick(item) {
    let msgText = "Please enter below details to add user access to this role."
    this._modalDialogContent = {
      subText: msgText,
      title: UIConstants.Labletext.AssignUser,
      okButtonText: UIConstants.ButtonText.Ok,
      type: DialogType.normal,
      okAction: () => this.addUserToRole(item),
      cancelAction: this.closeRemoveConfirmation,
      closeMessageAction: this.closeRemoveConfirmation,
      closeButtonAriaLabel: UIConstants.ButtonText.Cancel,
    }
    this.setState({ showDialog: true, modalDialogContent: this._modalDialogContent, isUserAssignmentButtonClick: true, selectedRole: item, userUpn: '', attributeValue: {}, comments: '' });
  }
  private closeRemoveConfirmation = (): void => {
    this.setState({ showDialog: false, isUserAssignmentButtonClick: false, userUpn: '', attributeValue: {}, comments: '' });
  };

  getRoleDefinitionColumns = (): IColumn[] => [
    { key: 'id', name: 'Id', fieldName: 'id', minWidth: 150, maxWidth: 300, isResizable: true },
    { key: 'name', name: 'Name', fieldName: 'name', minWidth: 150, maxWidth: 250, isResizable: true },
    { key: 'description', name: 'Description', fieldName: 'description', minWidth: 200, maxWidth: 400, isResizable: true },
    { key: 'scopes', name: 'Scopes', fieldName: 'scopes', minWidth: 150, maxWidth: 300, isResizable: true },
    { key: 'permissions', name: 'Permissions', fieldName: 'permissions', minWidth: 200, maxWidth: 400, isResizable: true, onRender: (item: Role) => typeof item.permissions === 'object' ? JSON.stringify(item.permissions) : String(item.permissions ?? '') },
    { key: 'createdOn', name: 'Created On', fieldName: 'createdOn', minWidth: 150, maxWidth: 300, isResizable: true },
    { key: 'updatedOn', name: 'Updated On', fieldName: 'updatedOn', minWidth: 150, maxWidth: 300, isResizable: true },
    { key: 'editrole', name: '', fieldName: 'editrole', minWidth: 70, maxWidth: 70, isResizable: false, onRender: this._onRenderItemColumn },
    { key: 'removerole', name: '', fieldName: 'removerole', minWidth: 70, maxWidth: 70, isResizable: false, onRender: this._onRenderItemColumn },
    { key: 'assignuser', name: '', fieldName: 'assignuser', minWidth: 70, maxWidth: 70, isResizable: false, onRender: this._onRenderItemColumn },
  ];

  private _onRenderItemColumn = (item: any, index: number, column: IColumn): JSX.Element | React.ReactText => {
    const itemClass = mergeStyles({
      selectors: {
        '&:hover': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    });
    if (column.key === 'delete') {
      return (
        <div className={itemClass}>
          <Link
            role="button" aria-label={UIConstants.ButtonText.Remove}
            onClick={() => { this.onRemoveAssignmentClick(item); }}
          > {UIConstants.ButtonText.Remove} </Link>
        </div>
      );
    }
    if (column.key === 'edit') {
      return (
        <div className={itemClass}>
          <Link role="button" aria-label={UIConstants.ButtonText.Edit}
            onClick={() => { this.handleAdminRowClick(item); }}
          > {UIConstants.ButtonText.Edit} </Link>
        </div>
      );
    }
    if (column.key === 'editrole') {
      return (
        <div className={itemClass}>
          <Link role="button" aria-label={UIConstants.ButtonText.Edit}
            onClick={() => { this.handleRowClick(item); }}
          > {UIConstants.ButtonText.Edit} </Link>
        </div>
      );
    }
    if (column.key === 'removerole') {
      return (
        <div className={itemClass}>
          <Link
            role="button" aria-label={UIConstants.ButtonText.Remove}
            onClick={() => { this.onRemoveRoleClick(item); }}
          > {UIConstants.ButtonText.Remove} </Link>
        </div>

      );
    }
    if (column.key === 'assignuser') {
      return (
        <div className={itemClass}>
          <Link
            role="button" aria-label={UIConstants.ButtonText.Add}
            onClick={() => { this.onAssignUserButtonClick(item); }}
          > {UIConstants.Labletext.AssignUser} </Link>
        </div>

      );
    }
    return item[column.key];
  };
  handleRowClick = (item: any) => {
    const perm = Array.isArray(item.permissions) && item.permissions.length > 0 ? item.permissions[0] : { actions: [], notActions: [], condition: '' };
    this.setState({
      selectedRole: item,
      isPaneOpen: true,
      isRoleUpdated: true,
      editedDescription: item.description || '',
      editedName: item.name || '',
      editedScope: Array.isArray(item.scopes) ? item.scopes.join(', ') : (item.scopes || ''),
      editedPermission: {
        actions: Array.isArray(perm.actions) ? [...perm.actions] : [],
        notActions: Array.isArray(perm.notActions) ? [...perm.notActions] : [],
        condition: perm.condition || ''
      },
      submitDisabled: false,
      editPaneMessage: null,
    });
  };

  handleAdminRowClick = (item: RoleAssignment) => {
    this.setState({
      selectedRole: item,
      isPaneOpen: true,
      isRoleUpdated: false,
      editedDescription: item.roleDescription || '',
      editedName: item.roleName || '',
      editedScope: item.scope || '',
      submitDisabled: false,
      editPaneMessage: null
    });
  };

  handlePaneClose = () => {
    this.setState({ isPaneOpen: false, selectedRole: null, submitDisabled: false, editPaneMessage: null, isRoleUpdated: false });
  };

  handleRoleDefinitionSubmit = async (updatedRole: any) => {
    const { tenantId, tenantData, isRoleUpdated, isCreateNew } = this.state;
    if (!updatedRole || !tenantId) return;
    this.setState({ isSubmitting: true, editPaneMessage: null });
    if (isRoleUpdated) {
      try {
        var url = URLHelper.UpdateRoleDefinition();
        const response = await axioClient.post(url + `?tenantId=${tenantId}`, updatedRole);
        const perm = Array.isArray(response.data.permissions) && response.data.permissions.length > 0 ? response.data.permissions[0] : { actions: [], notActions: [], condition: '' };
        this.setState({
          isSubmitting: false,
          isPaneOpen: true, // Keep the pane open
          selectedRole: response.data,
          editedDescription: response.data.description || '',
          editedName: response.data.name || '',
          editedScope: Array.isArray(response.data.scopes) ? response.data.scopes.join(', ') : (response.data.scopes || ''),
          editedPermission: {
            actions: Array.isArray(perm.actions) ? [...perm.actions] : [],
            notActions: Array.isArray(perm.notActions) ? [...perm.notActions] : [],
            condition: perm.condition || ''
          },
          submitDisabled: true,
          editPaneMessage: isCreateNew ? 'Role definition created successfully.' : 'Role definition updated successfully.',
        });
      } catch (error) {
        this.setState({ isSubmitting: false, editPaneMessage: error?.message || (isCreateNew ? 'Failed to create role definition.' : 'Failed to update role definition.') });
      }
    } else {
      try {
        const response = await axioClient.post(
          URLHelper.UpdateRoleAssignment() + `?tenantId=${tenantId}`,
          updatedRole
        );
        this.setState({
          isSubmitting: false,
          isPaneOpen: true, // Keep the pane open
          selectedRole: response.data,
          submitDisabled: true,
          editPaneMessage: 'Role assignment updated successfully.',
        });
      } catch (error) {
        this.setState({ isSubmitting: false, editPaneMessage: error?.message || 'Failed to update role assignment.' });
      }
    }
  };

  private renderMessage = () => {
    let { message, showMessage } = this.state;
    if (showMessage) {
      setTimeout(() => { this.setState({ showMessage: false }) }, 10000); // hide message after 3 seconds
    }
    return <div role="alert" >
      <MessageBar key='SaveMsg' style={{ fontSize: '.875rem' }}
        actions={
          <div>
            <IconButton role="button" iconProps={{ iconName: 'Clear' }} title="Close" onClick={() => { this.setState({ showMessage: false }) }} />
          </div>
        }
        messageBarType={MessageBarType.info}
        isMultiline={false}
      >
        <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{message}</span>
      </MessageBar>
    </div>
  };
  handleNextPage = () => {
    const { nextPageUrl, adminRoles } = this.state;
    if (nextPageUrl || adminRoles.length >= 100) {
      this.fetchRoleAssignments(nextPageUrl);
    }
  };

    handleSearchPrincipalIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchPrincipalId: e.target.value });
    };

  handleSearchRoleNameChange = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    this.setState({ searchRoleName: newValue || '' });
  };
  handleSearchPrincipalId = async () => {
        const { tenantId, searchPrincipalId } = this.state;
        if (!tenantId || !searchPrincipalId) return;

        // First, try server-side search by principal ID/UPN/Alias
        this.setState({ adminLoading: true, adminError: null, showRecordLimitWarning: false, isSearchApplied: true });
        try {
            const url = URLHelper.SearchRoleAssignmentByPrincipalId(tenantId, searchPrincipalId);
            const response = await axioClient.get(url);
            const userAccesses: RoleAssignment[] = response.data || [];
            const adminColumns = this.getDynamicRoleAssignmentColumns(userAccesses);
            const showWarning = userAccesses.length >= 200;
            this.setState({ adminRoles: userAccesses, adminColumns, adminLoading: false, nextPageUrl: null, showRecordLimitWarning: showWarning });
        } catch (err) {
            this.setState({ adminError: err.message || 'Unknown error', adminLoading: false, showRecordLimitWarning: false });
        }
    };
  renderAssignUserFields = () => {
    const { selectedRole, attributeValue, comments, userUpn } = this.state;
    return (
      <div>
        <TextField
          label="User UPN"
          value={userUpn}
          onChange={(ev, newValue) => { this.setState({ userUpn: newValue }) }}
          placeholder="Enter User UPN (Ex: abc@microsoft.com)"
          styles={{ root: { width: '100%' } }}
        />
        {selectedRole && selectedRole.attributes && selectedRole.attributes
          .filter(attr => attr !== 'UserAlias' && attr !== 'RoleSetToExpire')
          .map(attr => (
            <TextField
              key={attr}
              label={attr}
              value={Array.isArray(attributeValue[attr]) ? attributeValue[attr].join(";") : (attributeValue[attr] || '')}
              onChange={(ev, newValue) => {
                this.setState({
                  attributeValue: { ...attributeValue, [attr]: newValue.split(";").map(val => val.trim()) }
                });
              }}
              placeholder="Enter Attribute Values (Ex: abc;def)"
              styles={{ root: { width: '100%' } }}
            />
          ))
        }
        <TextField
          label="Comments" required
          value={comments}
          onChange={(ev, newValue) => { this.setState({ comments: newValue }) }}
          placeholder="Enter Justification"
          styles={{ root: { width: '100%' } }}
        />
      </div>
    );
  };

  render() {
    const { roles, loading, error, tenantData, adminRoles, adminLoading, adminError, nextPageUrl, searchPrincipalId, searchRoleName, selectedRole, isPaneOpen, editPaneMessage, submitDisabled, showDialog, modalDialogContent, showMessage, isUserAssignmentButtonClick, showRecordLimitWarning, isSearchApplied } = this.state;

    // Filter roles by role name
    const filteredRoles = roles.filter(role => 
      !searchRoleName || 
      (role.name && role.name.toLowerCase().includes(searchRoleName.toLowerCase()))
    );
    return (
      <div className="mr">
        {(showMessage && !showDialog) && this.renderMessage()}
        <div className="mr">
          <strong>Tenant Data:</strong>
          <pre style={{ background: NeutralColors.gray20, padding: 8 }}>{tenantData ? JSON.stringify(tenantData, null, 2) : 'Loading tenant...'}</pre>
        </div>
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Label style={{ paddingLeft: 10, fontSize: 20, margin: 0 }}>
              <h1 className={"h1"} style={{ paddingLeft: 0, fontSize: 20, margin: 0, display: 'inline' }}>Role Definitions</h1>
            </Label>
            <span>&nbsp;&nbsp;</span>
            <TextField
              placeholder="Search by Role Name or Description"
              value={searchRoleName}
              onChange={this.handleSearchRoleNameChange}
              style={{ width: 375, marginLeft: 16, marginRight: 8 }}
            />
            <span>&nbsp;&nbsp;</span>
            <DefaultButton title="Refresh" onClick={this.fetchRoleDefinitions}><Icon iconName={'Refresh'} />&nbsp;Refresh</DefaultButton>
            <span>&nbsp;&nbsp;</span>
            <DefaultButton title="Create Role" onClick={this.handleCreateRoleDefinition}><Icon iconName={'AddIn'} />&nbsp;Create Role</DefaultButton>
          </div>
          {loading && <p>Loading role definitions...</p>}
          {error && <p className="edit-pane-message error">{error}</p>}
          {!loading && !error && (filteredRoles?.length > 0) && (
            <div className="table-container">
              <ScrollablePane>
                <Fabric>
                  <DetailsList
                    items={filteredRoles}
                    columns={this.getRoleDefinitionColumns()}
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                    styles={{ root: { background: 'white', width: '100%' } }}
                    onRenderDetailsHeader={(props, defaultRender) => (
                      <Sticky stickyPosition={StickyPositionType.Header}>
                        {defaultRender!(props)}
                      </Sticky>
                    )}
                  />
                </Fabric>
              </ScrollablePane>
            </div>
          )}
        </div>
        <div style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <Label style={{ paddingLeft: 10, fontSize: 18, margin: 0 }}>
              <h1 className={"h1"} style={{ paddingLeft: 0, fontSize: 18, margin: 0, display: 'inline' }}>Role Assignments</h1>
            </Label>
            <span>&nbsp;&nbsp;</span>
            <TextField
              placeholder="Search by Principal Id / UPN / Alias / Role Name"
              value={searchPrincipalId}
              onChange={this.handleSearchPrincipalIdChange}
              style={{ padding: 8, fontSize: 16, width: 375, marginLeft: 16, marginRight: 8 }}
            />
            <span>&nbsp;&nbsp;</span>
            <PrimaryButton title="Search" onClick={this.handleSearchPrincipalId}><Icon iconName={'Search'} /></PrimaryButton>
          <span>&nbsp;&nbsp;</span>
            <DefaultButton title="Refresh" onClick={() => this.fetchRoleAssignments()} ><Icon iconName={'Refresh'} />&nbsp;Refresh</DefaultButton>
          </div>
          {adminLoading && <p>Loading role assignments...</p>}
          {adminError && <p className="edit-pane-message error">{adminError}</p>}
          {!adminLoading && !adminError && isSearchApplied && showRecordLimitWarning && (
            <MessageBar messageBarType={MessageBarType.warning} style={{ marginBottom: 8 }}>
              Displaying only the latest 200 records since role assignments exceed 200.
            </MessageBar>
          )}
          {!adminLoading && !adminError && adminRoles.length > 0 && (
            <>
              <div className="table-container">
                <ScrollablePane>
                  <Fabric>
                    <DetailsList
                      items={adminRoles}
                      columns={this.getDynamicRoleAssignmentColumns(adminRoles)}
                      setKey="admin-set"
                      layoutMode={DetailsListLayoutMode.justified}
                      selectionMode={SelectionMode.none}
                      styles={{ root: { background: 'white', width: '100%' } }}
                      onRenderDetailsHeader={(props, defaultRender) => (
                        <Sticky stickyPosition={StickyPositionType.Header}>
                          {defaultRender!(props)}
                        </Sticky>
                      )}
                    />
                  </Fabric>
                </ScrollablePane>
              </div>
              {!isSearchApplied && (nextPageUrl || adminRoles.length >= 100) && (
                <div className="mr">
                  <DefaultButton onClick={this.handleNextPage}>Next Page</DefaultButton>
                </div>
              )}
            </>
          )}
        </div>
        {showDialog && <ModalDialog hidden={!showDialog}
          onDismiss={this.closeRemoveConfirmation}
          dialogContentProps={modalDialogContent}
          modalProps={{
            titleAriaId: this._labelId,
            subtitleAriaId: this._subTextId,
            isBlocking: false,
            styles: { main: { maxWidth: 450 } },
          }}
          content={isUserAssignmentButtonClick && this.renderAssignUserFields()}
          showMessage={this.state.showMessage}
          message={this.state.message}
        >
        </ModalDialog>}
        {isPaneOpen && (
          <EditPane
            key={selectedRole.id}
            selectedRole={selectedRole}
            editPaneMessage={editPaneMessage}
            submitDisabled={submitDisabled}
            handlePaneClose={this.handlePaneClose}
            handleRoleDefinitionSubmit={this.handleRoleDefinitionSubmit}
            capitalizeFirstLetter={this.capitalizeFirstLetter}
          />
        )}
      </div>
    );
  }
}
